import React, { memo } from 'react';
import propTypes from 'prop-types';
import { stepIndicatorDatalocator } from './stepIndicatorDataLocator';
import './stepIndicator.scss';

const StepIndicatorTabs = ({ stepTitles, currentStep = 0, handleStepClick }) => {
    return (
        <div className="container">
            <div className="row stepform__row">
                <div className="col-lg-6">
                    <nav aria-label="Steps of your order">
                        <ol className="cca__stepindicator-step-form stepindicator">
                            {stepTitles?.map((text, index) => (
                                <li
                                    tabIndex={currentStep < index ? '-1' : '0'}
                                    key={index}
                                    data-testid={stepIndicatorDatalocator.step_heading}
                                    className={`cca__stepindicator-step ${currentStep === index ? 'active' : ''} ${
                                        currentStep > index ? 'completed' : ''
                                    }`}
                                    aria-current={currentStep === index ? 'step' : false}
                                    onClick={() => handleStepClick(index)}>
                                    <div aria-hidden={true} className="cca__stepindicator-step-line"></div>
                                    <div className="cca__stepindicator-step-text">
                                        <span className="visually-hidden">
                                            {' '}
                                            {`${currentStep === index ? 'current' : ''} ${
                                                currentStep > index ? 'completed' : ''
                                            }`}
                                        </span>
                                        {text}
                                    </div>
                                </li>
                            ))}
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    );
};

StepIndicatorTabs.propTypes = {
    stepTitles: propTypes.array,
    currentStep: propTypes.number,
    handleStepClick: propTypes.func
};
StepIndicatorTabs.defaultProps = {
    stepTitles: [],
    currentStep: 0,
    handleStepClick: () => {}
};
export default memo(StepIndicatorTabs);
